/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_Setting_Group_SetclipInputs */

const en_enum_setting_group_setclip = /** @type {(inputs: Enum_Setting_Group_SetclipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Group Setclip`)
};

const de_enum_setting_group_setclip = /** @type {(inputs: Enum_Setting_Group_SetclipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gruppe Setclip`)
};

/**
* | output |
* | --- |
* | "Group Setclip" |
*
* @param {Enum_Setting_Group_SetclipInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const enum_setting_group_setclip = /** @type {((inputs?: Enum_Setting_Group_SetclipInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_Setting_Group_SetclipInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_setting_group_setclip(inputs)
	return de_enum_setting_group_setclip(inputs)
});